var path = 'app/scripts/modules/google/src/pipeline/stages/destroyAsg/destroyAsgStepLabel.html';
var html = "<span class=\"task-label\"> Destroy Server Group: {{step.context.serverGroupName}} ({{step.context.region}}) </span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;